import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-delete-group-with-incoming-dialog',
  imports: [TranslateModule, CommonModule, FormsModule, DialogModule],
  templateUrl: './delete-group-with-incoming-dialog.component.html',
  styleUrl: './delete-group-with-incoming-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteGroupWithIncomingDialogComponent {
  @Input() visible = false;
  @Input() closing = false;
  @Input() restoreWithoutTransition = false;
  @Input() groupName = '';
  @Input() incomingActivitiesCount = 0;
  @Input() confirmed = false;

  @Output() closed = new EventEmitter<void>();
  @Output() hidden = new EventEmitter<void>();
  @Output() confirmedChange = new EventEmitter<boolean>();
  @Output() deleteConfirmed = new EventEmitter<void>();

  onConfirmedChange(value: boolean) {
    this.confirmedChange.emit(value);
  }

  close() {
    this.closed.emit();
  }

  onHidden() {
    this.hidden.emit();
  }

  confirm() {
    this.deleteConfirmed.emit();
  }
}
